// import 'css.escape';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, useLocation, useHistory } from "react-router-dom";
import './index.less';
import * as zoid from 'zoid/dist/zoid.frameworks.js';
import { setToken } from './shared/rest';
import { getUserIdToken } from './shared/localStorage';
import App from './App';

import * as Logger from '@crimson-education/browser-logger';
import config from './config';

// eslint-disable-next-line no-restricted-globals
const CommunityComponent = zoid.create({
  // The html tag used to render my component
  tag: 'community-component',
  // The url that will be loaded in the iframe or popup, when someone includes my component on their page
  url: `${process.env.DOMAIN ||
    'https://community-staging.crimsoneducation.org'}`,

  // The size of the component on their page. Only px and % strings are supported
  dimensions: {
    width: '1195px',
    height: '766px',
  },

  props: {
    history: {
      type: 'object',
      isRequired: true,
    },
    tokens: {
      type: 'object',
      isRequired: true,
    },
    onMessage: {
      type: 'function',
      required: true,
    },
    checkLogin: {
      type: 'function',
      required: true,
    },
    domain: {
      type: 'string',
      required: true,
    },
  },
});

const isLocalhost = window.location.hostname === 'localhost';

try {
  Logger.init({
    service: 'crimson-community',
    environment: config.environment,
    version: config.version,
    defaultMetadata: {
      application: 'crimson-community',
    },
    reporters: {
      log: true,
      amplify:
        !isLocalhost && config.pinpointAnalyticsAppId
          ? {
              region: config.awsRegion,
              identityPoolId: config.pinpointIdentityPoolId,
              analyticsAppId: config.pinpointAnalyticsAppId,
              proxyUrl: config.pinpointProxyUrl,
              autoTrackPageViews: true,
              autoTrackEvents: true,
              autoTrackSessions: true,
            }
          : undefined,
    },
  });
} catch (e) {
  console.warn('Logger init error', e);
}

const idToken = getUserIdToken();
if (idToken) {
  setToken(idToken);
} else {
  console.error('token missing!');
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* @ts-ignore: Unreachable code error */}
      <App {...window.xprops} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
